import { faDoorOpen, faPersonToDoor } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { Role } from '../../graphql/schema';
import hasRole from '../../helper/hasRole';
import Button from '../base/Button';

const Header = () => {
  const navigate = useNavigate();
  const { signinRedirect, isAuthenticated, removeUser, user } = useAuth();

  return (
    <div className="flex w-full justify-between mb-4">
      <div className="w-[200px] flex items-center">
        <img src="/images/logo.svg" alt="" />
      </div>
      <div className="flex items-center justify-end space-x-5">
        {hasRole(user, [Role.ADMIN, Role.USER]) && (
          <Button label="Alben" onClick={() => navigate('/')} />
        )}

        {hasRole(user, [Role.ADMIN]) && (
          <Button label="Alben verwalten" onClick={() => navigate('/albums')} />
        )}

        {isAuthenticated && (
          <div
            className="cursor-pointer p-3"
            onClick={async () => {
              await removeUser();
              window.location.href = '/';
            }}
          >
            <FontAwesomeIcon icon={faPersonToDoor} />
          </div>
        )}
        {!isAuthenticated && (
          <div className="cursor-pointer p-3" onClick={() => signinRedirect()}>
            <FontAwesomeIcon icon={faDoorOpen} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
